import React from 'react';
import { Modal } from '@/components/ui';

// ResponsiveModal (quantified-tracking) — legacy wrapper kept for its existing call sites
// (TaskModal, H200TaskModal, the standing-task modals, …). It now delegates to the shared
// `ui/Modal` primitive instead of hand-rolling a `.modal-dialog` overlay.
//
// Why this changed: the old version emitted `mobile-fullscreen mobile-{orientation}` on
// phones — class names with no CSS definition anywhere in the repo — so on a phone these
// modals lost all sizing and rendered unstyled. Delegating also gains the focus trap,
// body-scroll lock, ESC handling, pinned header/footer and transitions.
// Prefer using `Modal` directly in new code.
interface ResponsiveModalProps {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  title: string;
  footer?: React.ReactNode;
}

const ResponsiveModal: React.FC<ResponsiveModalProps> = ({
  children,
  isOpen,
  onClose,
  title,
  footer,
}) => (
  // '2xl' ≈ the old `.standardized-modal` 1200px desktop width.
  <Modal show={isOpen} onHide={onClose} size="2xl">
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>{children}</Modal.Body>
    {footer && <Modal.Footer>{footer}</Modal.Footer>}
  </Modal>
);

export default ResponsiveModal;
